import React from 'react'

const Tiktok = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
<path d="M19.65 4H15.9423V18.9855C15.9423 20.771 14.5163 22.2377 12.7417 22.2377C10.9671 22.2377 9.54113 20.771 9.54113 18.9855C9.54113 17.2319 10.9355 15.7971 12.6467 15.7333V11.971C8.87565 12.0348 5.8335 15.1275 5.8335 18.9855C5.8335 22.8754 8.93903 26 12.7734 26C16.6078 26 19.7133 22.8435 19.7133 18.9855V11.3014C21.1077 12.3217 22.8189 12.9275 24.6252 12.9594V9.1971C21.8365 9.10145 19.65 6.80579 19.65 4Z" fill="currentColor"></path>
</svg>
    )
}

export default Tiktok
